import { TextField, TextFieldProps } from '@cimpress/react-components';
import React, { ReactElement, useEffect, useState } from 'react';

interface TypeaheadTextFieldProps extends Omit<TextFieldProps, 'onChange'|'value'>, React.RefAttributes<HTMLInputElement> {
    options: string[],
    onChange: (newValue: string) => void,
    value: string | undefined,
}
export default function TypeaheadTextField(props: TypeaheadTextFieldProps): ReactElement {
    const [query, setQuery] = useState<string>(props.value ?? '');
    const [filteredSuggestions, setFilteredSuggestions] = useState<string[]>([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(() => {
        console.log(query);
        props.onChange(query ?? '');
    }, [query]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setQuery(value);

        if (value.trim().length > 0) {
            const filtered = props.options.filter((option) =>
                option.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredSuggestions(filtered);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelect = (suggestion: string) => {
        setQuery(suggestion);
        setFilteredSuggestions([]);
        setShowSuggestions(false);
    };

    return <>
        <TextField {...props} onChange={handleChange} value={query}></TextField>
        {showSuggestions && filteredSuggestions.length > 0 && (
            <div style={{position: 'absolute', width: 400}}>
                <ul style={{
                    position: 'absolute',
                    top: '100%',
                    left: '20px',
                    right: '20px',
                    border: '1px solid #ccc',
                    background: '#fff',
                    margin: 0,
                    padding: 0,
                    listStyle: 'none',
                    zIndex: 1000
                }}>
                    {filteredSuggestions.map((suggestion, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(suggestion)}
                            style={{ padding: '8px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                        >
                            {suggestion}
                        </li>
                    ))}
                </ul>
            </div>
        )}
    </>;
}